export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 50;

export const isPasswordLengthValid = (password: string): boolean => (
  password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH
);

export const isPasswordValid = (password: string): boolean => (
  isPasswordLengthValid(password) && /\p{L}/u.test(password)
);
